/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var ActionAuthorization;
(function (ActionAuthorization) {
    ActionAuthorization["ALLOW"] = "allow";
    ActionAuthorization["DENY"] = "deny";
    ActionAuthorization["SKIP"] = "skip";
})(ActionAuthorization || (ActionAuthorization = {}));
